<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">资产类别</span>
      <span class="dark4-color ">提示：按 Ctrl + F 键并输入可以快速查找。</span>
    </div>
    <div class="margin-right-left margin-top">
<!--      <Button color="primary" @click="showForm=true">新增</Button>-->
    </div>
    <div class="h-panel-body">
      <Table :datas="datas" :border="true">
        <TableItem title="序号" :width="80">
          <template v-slot="{ index }">{{ index + 1 }} </template>
        </TableItem>
        <TableItem title="资产编码"  prop="categoryCode" ></TableItem>
        <TableItem title="资产名称" prop="categoryName"></TableItem>
        <TableItem title="备注" prop="remark"></TableItem>
        <TableItem title="使用期限/月" prop="usefulLife" :width="80"></TableItem>

        <TableItem title="操作" :width="100" align="center">
<!--          <div class="actions" slot-scope="{data}" v-if="!data.localCurrency">-->
<!--            <span @click="edit(data)">编辑</span>-->
<!--            <span @click="remove(data)">删除</span>-->
<!--          </div>-->
        </TableItem>
      </Table>
    </div>
    <Modal v-model="showForm" hasCloseIcon type="drawer-right">
      <div slot="header">资产类别设置</div>
      <Form ref="form" v-width="500" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="资产编号" prop="categoryCode">
          <input type="text" v-model="form.categoryCode">
        </FormItem>
        <FormItem label="资产名称" prop="categoryName">
          <input type="text" v-model="form.categoryName">
        </FormItem>
        <FormItem label="备注" prop="remark">
          <input type="text" v-model="form.remark">
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false">取消</Button>
      </div>
    </Modal>

  </app-content>
</template>
<script>
const emptyForm = {
  "categoryCode": "",
  "categoryName": "",
  "remark": "",
  "usefulLife": "",
  "id": "",
};
/**
 * 用于资产类别管理。
 *
 */
export default {
  data() {
    return {
      datas: [],
      select: {},
      form: Object.assign({}, emptyForm),
      showForm: false,
      loading: false,
      validationRules: {
        required: ["categoryCode", "categoryName", ]
      }
    }
  },
  watch: {
    showForm(val) {
      if (!val) {
        this.reset();
      }
    }
  },
  mounted() {
    this.loadList();
  },
  methods: {
       /**
     * 从后端 API 获取资产类别列表数据，并更新组件的 datas 属性。
     * 若请求失败，将打印错误信息。
     */
    async loadList() {
      try {
        // 等待 API 请求完成
        const response = await this.$api.assets.assetsType.list();
        // 将响应数据中的 data 字段赋值给组件的 datas 属性
        this.datas = response.data || [];
      } catch (error) {
        // 打印请求失败的错误信息
        console.error('获取资产类别列表失败:', error);
      }
    },
    reset() {
      this.form = Object.assign({}, emptyForm)
    },
    // reset() {
    //   this.form = {};
    //   this.$refs.form.resetFields();
    // },
       async submit() {
      // 调用表单验证方法，获取验证结果
      let validResult = this.$refs.form.valid();
      // 判断表单验证是否通过
      if (validResult.result) {
        try {
          // 验证通过，开启加载状态，防止用户重复提交
          this.loading = true;
          // 根据表单是否有 id 决定调用更新或保存接口
          await this.$api.assets.assetsType[this.form.id ? 'update' : 'save'](this.form);
          // 操作成功，刷新资产类别列表
          this.loadList();
          // 关闭表单弹窗
          this.showForm = false;
        } catch (error) {
          // 操作失败，添加错误提示
          console.error('提交表单失败:', error);
          this.$Message.error('提交表单失败，请稍后重试');
        } finally {
          // 关闭加载状态
          this.loading = false;
        }
      }
    },

    remove(data) {

      this.$Confirm("确认删除?").then(async () => { // 使用 async 关键字
        try {
          // 等待异步请求完成，获取资产列表数据
          const response = await this.$api.assets.assets.list();
          const assets = response.data || [];
          const assets1 = assets.filter(asset => asset.assetsTypeId === data.id);
          if(assets1.length > 0){
            this.$Message.error('该类别下已存在固定资产信息，不能删除！');
            return;
          }
          // 若该类别下无固定资产信息，执行删除操作
            this.$api.assets.assetsType.delete(data.id).then(() => {
              this.loadList();
            })
        } catch (error) {
          console.error('删除资产类别失败:', error);
          this.$Message.error('删除资产类别失败，请稍后重试');
        }
      });
    },
    edit(data) {
      this.form = Object.assign({}, data)
      this.showForm = true;
    }
  }

}
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center; /* 垂直居中对齐 */
}


</style>